export default __webpack_public_path__ + "static/media/45.56f1d62f.jpg";